"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppInfo = exports.isApp = exports.iOS = exports.isAndroid = void 0;
var APP_UA_REGEXP = /(akulaku|silvrrplus)\/([\d+.]+)/;
function isAndroid() {
    return /(Android)/i.test(window.navigator.userAgent);
}
exports.isAndroid = isAndroid;
function iOS() {
    return (["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document));
}
exports.iOS = iOS;
function isApp() {
    var ua = window.navigator.userAgent;
    return /akulaku|silvrrplus/gi.test(ua);
}
exports.isApp = isApp;
function getAppInfo() {
    var ua = window.navigator.userAgent;
    var matched = ua.match(APP_UA_REGEXP);
    if (matched && matched.length > 0) {
        return {
            appName: (matched[1] || ""),
            version: matched[2] || "",
        };
    }
    return {
        appName: "",
        version: "",
    };
}
exports.getAppInfo = getAppInfo;
